import _ from 'lodash'
import { findIndex } from 'lodash';

export default {
  take(state) {
    return state.take
  },

  currentAnswerId(state) {
    return state.currentAnswerId
  },

  currentQuestionResult(state) {
    return state.currentQuestionResult
  },

  currentQuestion(state) {
    if (!state.currentQuestionId) return null
    const curQuestion = state.questions.find(q => q.id == state.currentQuestionId)

    const result = _.extend({}, curQuestion)
    result.answers = result.answers.map(answer => answerRepresentation(state, answer))

    return result
  },

  quizPassed(state) {
    return state.take.quiz_passed
  },

  questionIndex(state, getters) {
    const id = getters.currentQuestion.id;
    const questions = state.questions;
    return findIndex(questions, { id })
  },

  questionsLength(state) {
    const questions = state.questions;
    return questions.length
  },
}

function answerRepresentation(state, answer) {
  return _.extend({ checked: (answer.id == state.currentAnswerId) }, answer)
}
